// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 97) return "static/chunks/97-ca77494f5d7125d2.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 10 ? "ca20e1c9" : chunkId) + "." + {"10":"2fcfa15237b74a67","108":"5c02f0d280011efd","251":"2296e5341070e965","452":"10097658bf3f0cb3","573":"6deb810744354454","670":"a4277c7317981dd0","673":"d77cdae3d98a7ad9"}[chunkId] + ".js";
};